import {
  drawCenteredBoldPrefixRow,
  drawFullWidthRow,
  drawMainSidesRow,
  joinLabelValue,
  PAD,
  rowHeightMm,
} from './htPdfRowDraw';
import {
  formatHtQuantityTreated,
  formatHtTreatmentDateDisplay,
} from './htDisplayFormat';
import { htPdfDrawFullWidthRowFrame } from './htPdfFullWidthFrame';

const TREAT_PAD = PAD;

const TREAT_ROW_PT = {
  36: 11.5,
  37: 11.5,
  38: 11.5,
  39: 11.5,
  40: 11.5,
  41: 4,
  42: 11.5,
  43: 11.5,
};

/** Filas 36–43: lote, parámetros de tratamiento y observación. */
export function drawHtTreatmentBlockPdf(doc, params, xs, y) {
  const S = params.static;
  const rowOpts = { pad: TREAT_PAD };
  doc.setFont('helvetica', 'normal');

  y = drawMainSidesRow(
    doc,
    xs,
    y,
    36,
    S.HT_LOT_LINE,
    S.HT_CYCLE_LINE,
    TREAT_ROW_PT,
    rowOpts
  );

  y = drawMainSidesRow(
    doc,
    xs,
    y,
    37,
    joinLabelValue(S.HT_QTY_TREATED_LABEL, formatHtQuantityTreated(params.quantityTreated)),
    S.HT_TREATMENT_PARAMS_LABEL,
    TREAT_ROW_PT,
    rowOpts
  );
  y = drawMainSidesRow(
    doc,
    xs,
    y,
    38,
    joinLabelValue(S.HT_SCIENTIFIC_LABEL, S.HT_SCIENTIFIC_VALUE),
    S.HT_TEMP_ACTUAL,
    TREAT_ROW_PT,
    rowOpts
  );
  y = drawMainSidesRow(
    doc,
    xs,
    y,
    39,
    joinLabelValue(
      S.HT_DATE_TREAT_LABEL,
      formatHtTreatmentDateDisplay(params.treatmentDateIso)
    ),
    S.HT_TEMP_PARAM,
    TREAT_ROW_PT,
    rowOpts
  );
  y = drawMainSidesRow(
    doc,
    xs,
    y,
    40,
    joinLabelValue(S.HT_TIME_LABEL, S.HT_TIME_VALUE),
    S.HT_EXPOSURE,
    TREAT_ROW_PT,
    rowOpts
  );

  const h41 = rowHeightMm(41, TREAT_ROW_PT);
  htPdfDrawFullWidthRowFrame(doc, xs, y, h41, 41, []);
  y += h41;

  y = drawCenteredBoldPrefixRow(
    doc,
    xs,
    y,
    42,
    S.HT_PLACE_TREAT_LABEL,
    S.HT_PLACE_TREAT_SUFFIX,
    TREAT_ROW_PT,
    rowOpts
  );
  y = drawFullWidthRow(
    doc,
    xs,
    y,
    43,
    joinLabelValue(S.HT_REMARK_LABEL, params.remarkBlInvoice),
    TREAT_ROW_PT,
    rowOpts
  );

  return y;
}
